import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getOrgUnitAthleteEntryRosterSelectionData from './GetOrgUnitAthleteEntryRosterSelectionData';
import postOrgUnitAthleteEntryRosterSelectionData from './PostOrgUnitAthleteEntryRosterSelectionData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const OmeMeetOrgUnitAthleteEntryRosterSelectionData = {
  INITIAL_STATE, getOrgUnitAthleteEntryRosterSelectionData, postOrgUnitAthleteEntryRosterSelectionData
}

export default OmeMeetOrgUnitAthleteEntryRosterSelectionData;